import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { selectPollTemplateById } from 'features/polls/pollsSlice';
import { usePollTemplates } from 'features/polls/hooks/usePollTemplates';
import { deletePollTemplateRequested } from 'features/polls/actions';

const DeletePollTemplateConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const templateId = modalData.id as string;

  const { templatesAvailable, canManageTemplates } = usePollTemplates();

  const template = useAppSelector((state) => selectPollTemplateById(state, templateId));

  const shouldClose = !templatesAvailable || !canManageTemplates || !template;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('deletePollTemplate'));
    }
  }, [shouldClose, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('deletePollTemplate'));
  };

  const handleOk = () => {
    dispatch(deletePollTemplateRequested({ id: templateId }));
    dispatch(closeModal('deletePollTemplate'));
  };

  return (
    <ConfirmationDialog
      open={!shouldClose}
      title={t('polls.delete_poll_template.title')}
      description={t('polls.delete_poll_template.description')}
      cancelText={t('polls.delete_poll_template.btn_cancel_label')}
      okText={t('polls.delete_poll_template.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      hideCloseButton
      preventClose
    />
  );
};

export default DeletePollTemplateConfirmation;
